import { useEffect, useRef } from 'react';
import Hero from '../../components/section/Hero';
import ProgramInfoBar from '../../components/section/ProgramInfoBar';
import AboutProgram from '../../components/section/AboutProgram';
import WhyThisMatters from '../../components/section/WhyThisMatters';
import WhoShouldAttend from '../../components/section/WhoShouldAttend';
import KeyFocusAreas from '../../components/section/KeyFocusAreas';
import PartnerOpportunity from '../../components/section/PartnerOpportunity';
import WhatMakesValuable from '../../components/section/WhatMakesValuable';
import AboutAQT from '../../components/section/AboutAQT';
import FinalCTA from '../../components/section/FinalCTA';
// import Footer from '../../components/section/Footer';
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/navbar/index.jsx";

function App() {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.fade-in-section');
    elements.forEach((el) => observerRef.current?.observe(el));

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ProgramInfoBar />
      <AboutProgram />
      <WhyThisMatters />
      <WhoShouldAttend />
      <KeyFocusAreas />
      <PartnerOpportunity />
      <WhatMakesValuable />
      <AboutAQT />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
